import { compose, find, map, prop, propEq } from 'ramda'
import { useMemo } from 'react'

import {
  formatOptionsFromArrayWithTranslation,
  formatOptionsFromCollection,
  formatWrappedOptionsFromCollection
} from '../helpers/select'

export const useFormattedOptionsFromCollection = (labelKey, valueKey, array) => {
  return useMemo(
    () => formatOptionsFromCollection(labelKey || 'name', valueKey || 'id', array),
    [array, valueKey, labelKey]
  )
}
// TODO: Remove typo
export const useFormattedOptionsFromCollction = useFormattedOptionsFromCollection

// TODO: add useTranslation inside and remove from params
export const useTranslatedFormattedOptionsFromCollection = (t, prefix, labelKey, valueKey, array) => {
  const wrap = label => t(prefix + label, label)
  return useMemo(
    () => formatWrappedOptionsFromCollection(wrap, labelKey || 'name', valueKey || 'id', array),
    [prefix, array, valueKey, labelKey]
  )
}

// TODO: add useTranslation inside and remove from params
export const useTranslatedFormattedOptionsFromArray = (t, prefix, array) => {
  return useMemo(() => formatOptionsFromArrayWithTranslation(array, t, prefix), [prefix, array])
}

export const useLabelsFromSelectedOptions = (options, values) =>
  useMemo(
    () =>
      map(
        compose(prop('label'), id => find(propEq('value', id), options)),
        values
      ) || [],
    [options, values]
  )

export const useSelectedOptionsValues = (array = []) => useMemo(() => array.map(prop('value')), [array])
